import React from 'react'

const UserRevisionIcon = ({active}) => {
    return (
        <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.34759 5.85356C4.07902 3.13072 7.30555 1.29999 11 1.29999C16.5228 1.29999 21 5.39118 21 10.4379C21 15.4847 16.5228 19.5759 11 19.5759C5.47715 19.5759 1 15.4847 1 10.4379" stroke= {active? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.25 5.86895H2.25V1.29999" stroke={active? "white" : "black"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default UserRevisionIcon